import { Typography, Icon } from '../kit';
import { themeColors } from '../theme/theme';

const CARD_STEPS = [
  {
    key: 'origin',
    label: 'From',
    icon: 'home',
  },
  {
    key: 'destination',
    label: 'To',
    icon: 'LocationOn',
  },
  {
    key: 'size',
    label: 'Size',
    icon: 'Inventory2',
  },
  {
    key: 'type',
    label: 'Type',
    icon: 'Category',
  },
];

export default function EstimatorProgressBar({ origin, destination, size, types, onCardClick }) {
  const steps = [
    { ...CARD_STEPS[0], value: origin },
    { ...CARD_STEPS[1], value: destination },
    { ...CARD_STEPS[2], value: size },
    { ...CARD_STEPS[3], value: types && types.length ? types.join(', ') : '' },
  ];
  const completed = steps.map((s) => Boolean(s.value));
  const progress = (completed.filter(Boolean).length / steps.length) * 100;

  return (
    <div
      style={{
        width: '100%',
        maxWidth: 600,
        margin: '32px auto 0',
        padding: '0 8px',
      }}
    >
      <div
        style={{
          display: 'flex',
          gap: 0,
          justifyContent: 'space-between',
          marginBottom: 12,
          border: `2px solid ${themeColors.primaryColor}`,
          borderRadius: 16,
          overflow: 'hidden',
          background: '#fff',
        }}
      >
        {steps.map((step, idx) => (
          <div
            key={step.key}
            onClick={() => onCardClick && onCardClick(step.key)}
            style={{
              flex: 1,
              background: completed[idx]
                ? 'linear-gradient(135deg, #e3f0ff 0%, #f6fafd 100%)'
                : '#f6fafd',
              borderRight:
                idx < steps.length - 1 ? `1.5px solid ${themeColors.primaryColor}` : 'none',
              borderRadius: 0,
              boxShadow: 'none',
              padding: '18px 8px 12px 8px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              position: 'relative',
              minWidth: 80,
              minHeight: 90,
              cursor: 'pointer',
              transition: 'background 0.2s, box-shadow 0.2s',
              borderBottom: '2.5px solid transparent',
            }}
            onMouseOver={(e) => (e.currentTarget.style.boxShadow = '0 2px 12px #e3f0ff')}
            onMouseOut={(e) => (e.currentTarget.style.boxShadow = 'none')}
          >
            <Icon
              name={step.icon || 'help_outline'}
              style={{
                fontSize: 22,
                color:
                  completed[idx] ||
                  step.key === 'size' ||
                  step.key === 'origin' ||
                  step.key === 'destination'
                    ? themeColors.primaryColor
                    : '#bbb',
                marginBottom: 8,
              }}
            />
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                marginBottom: 4,
              }}
            >
              <Typography
                type="body2"
                text={step.label}
                style={{
                  fontWeight: 400,
                  color: completed[idx] ? themeColors.primaryColor : '#bbb',
                }}
              />
            </div>

            {completed[idx] && (
              <Icon
                name="check"
                style={{
                  position: 'absolute',
                  top: 8,
                  right: 8,
                  color: themeColors.primaryColor,
                  fontSize: 18,
                }}
              />
            )}
          </div>
        ))}
      </div>
      {/* Progress bar */}
      <div
        style={{
          width: '100%',
          height: 8,
          background: '#e3f0ff',
          borderRadius: 8,
          overflow: 'hidden',
          marginBottom: 16,
        }}
      >
        <div
          style={{
            width: `${progress}%`,
            height: '100%',
            background: themeColors.primaryColor,
            borderRadius: 8,
            transition: 'width 0.3s',
          }}
        />
      </div>
      {/* Details summary removed as overlays are now used for all steps */}
    </div>
  );
}
